import { request, getCompanyId } from '../utils';
import { API_DOWNLOAD_INVOICES, API_FETCH_INVOICES, API_FETCH_MIS_SUMMARY, API_MIS_FETCH_PARTICIPANTS_LIST, API_INVOICE_CONFIRM, API_INVOICE_DISPUTE, API_DOWNLOAD_PARTICIPATION_LIST } from '../routes/api';

class InvoicesApi {
  static fetch_invoices(options, onSuccess, onError) {
    return request({ url: API_FETCH_INVOICES(getCompanyId(true)), ...options }, onSuccess, onError);
  }

  static download_invoices(options, onSuccess, onError) {
    return request({ url: API_DOWNLOAD_INVOICES, ...options, method: 'post' }, onSuccess, onError);
  }

  static fetch_mis_summary(options, onSuccess, onError) {
    return request({ url: API_FETCH_MIS_SUMMARY, ...options, method: 'post' }, onSuccess, onError);
  }

  static fetch_participants_list(options, onSuccess, onError) {
    return request({ url: API_MIS_FETCH_PARTICIPANTS_LIST, ...options, method: 'post' }, onSuccess, onError);
  }

  static confirm_invoice(options, onSuccess, onError) {
    return request({ url: API_INVOICE_CONFIRM, ...options, method: 'post' }, onSuccess, onError);
  }

  static dispute_invoice(options, onSuccess, onError) {
    return request({ url: API_INVOICE_DISPUTE, ...options, method: 'post' }, onSuccess, onError);
  }

  static download_participation_list(options, onSuccess, onError) {
    return request({ url: API_DOWNLOAD_PARTICIPATION_LIST, ...options, method: 'post' }, onSuccess, onError);
  }
  
}

export default InvoicesApi;
